module.exports = __webpack_public_path__ + "static/media/high_registered_and_unregistered.a2c73ca9.png";